import { render, staticRenderFns } from "./InsurerList.vue?vue&type=template&id=372f0433&scoped=true"
import script from "./InsurerList.vue?vue&type=script&lang=ts"
export * from "./InsurerList.vue?vue&type=script&lang=ts"
import style0 from "./InsurerList.vue?vue&type=style&index=0&id=372f0433&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372f0433",
  null
  
)

export default component.exports